import { Store } from 'laco'

const ModalStore = new Store({ show: false, components: [] })

export default ModalStore
